export default __webpack_public_path__ + "static/media/029-hat.fbcc03ab.svg";